/**
 * Site configuration - URLs for cross-site linking.
 * These can be overridden via environment variables for different environments.
 */

// Default URLs with environment variable overrides
export const KRULTRA_URLS = {
  legacy: process.env.REACT_APP_KRULTRA_LEGACY_URL || 'https://krultra.no',
  new: process.env.REACT_APP_KRULTRA_NEW_URL || 'https://prod.krultra.no',
  uploads: process.env.REACT_APP_KRULTRA_UPLOADS_URL || 'https://prod.krultra.no/uploads',
  stationaryImage: process.env.REACT_APP_KRULTRA_STATIONARY_IMAGE_URL || 'https://krultra.no/assets/email/krultra_stationary_top.png',
  logo: process.env.REACT_APP_KRULTRA_LOGO_URL || 'https://krultra.no/assets/krultra_logo_medium.png'
};

export const RUNNERSHUB_URLS = {
  main: process.env.REACT_APP_RUNNERSHUB_URL || 'https://runnershub.krultra.no',
  admin: process.env.REACT_APP_RUNNERSHUB_ADMIN_URL || 'https://runnershub.krultra.no/admin'
};

export const EXTERNAL_URLS = {
  stripe: {
    dashboard: process.env.REACT_APP_STRIPE_DASHBOARD_URL || 'https://dashboard.stripe.com',
    testDashboard: process.env.REACT_APP_STRIPE_TEST_DASHBOARD_URL || 'https://dashboard.stripe.com/test'
  },
  social: {
    facebookGroup: process.env.REACT_APP_KRULTRA_FACEBOOK_GROUP_URL || 'https://www.facebook.com/groups/146973852042384',
    facebookPage: process.env.REACT_APP_KRULTRA_FACEBOOK_PAGE_URL || 'https://www.facebook.com/krultra.no',
    instagram: process.env.REACT_APP_KRULTRA_INSTAGRAM_URL || 'https://www.instagram.com/krultra',
    twitter: process.env.REACT_APP_KRULTRA_TWITTER_URL || 'https://www.twitter.com/krultra'
  },
  services: {
    eqtiming: process.env.REACT_APP_EQTIMING_URL || 'https://signup.eqtiming.com',
    googleForms: process.env.REACT_APP_GOOGLE_FORMS_URL || 'https://docs.google.com',
    brreg: process.env.REACT_APP_BRREG_URL || 'https://virksomhet.brreg.no'
  }
};

// Legacy exports for backward compatibility
export const KRULTRA_URL = KRULTRA_URLS.legacy;
export const RUNNERSHUB_URL = RUNNERSHUB_URLS.main;
export const ARCHIVE_URL = KRULTRA_URLS.legacy;

/**
 * Build a krultra.no URL for a specific path.
 * @param path - Path without leading slash (e.g., "events/KUTC", "kutc")
 */
export function getKrultraUrl(path?: string): string {
  if (!path) return KRULTRA_URL;
  return `${KRULTRA_URL}/${path}`;
}

/**
 * Build a RunnersHub URL for a specific path.
 * @param path - Path without leading slash (e.g., "kutc-2026", "mo/results")
 */
export function getRunnersHubUrl(path?: string): string {
  if (!path) return RUNNERSHUB_URL;
  return `${RUNNERSHUB_URL}/${path}`;
}
